import type { EdgeDiagnostics } from '@/modules/management/api';

/**
 * Reads a request-path report the way the Diagnostika tab explains it. A reverse proxy appends the address it
 * saw to X-Forwarded-For, so only the LAST entry is the proxy's own record; earlier entries were sent by the
 * client or by a proxy further out and can be forged.
 */
export interface EdgeReading {
  /** The client address the nearest proxy recorded, and where it came from; null when nothing identifies one. */
  client: string | null;
  source: 'xff' | 'real_ip' | 'peer' | null;
  /** Entries before the last one: not vouched for by the proxy. */
  earlierHops: string[];
}

export function readEdge(view: EdgeDiagnostics): EdgeReading {
  const chain = view.x_forwarded_for;
  if (chain.length > 0) {
    return { client: chain[chain.length - 1], source: 'xff', earlierHops: chain.slice(0, -1) };
  }
  if (view.x_real_ip) return { client: view.x_real_ip, source: 'real_ip', earlierHops: [] };
  if (view.peer) return { client: view.peer, source: 'peer', earlierHops: [] };
  return { client: null, source: null, earlierHops: [] };
}

export const EDGE_SOURCE_LABEL: Record<NonNullable<EdgeReading['source']>, string> = {
  xff: 'poslední záznam X-Forwarded-For',
  real_ip: 'X-Real-IP',
  peer: 'adresa spojení (bez proxy)',
};
